var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4937 52.1749H20.0354C14.5675 52.1749 11.1085 51.0727 8.98068 48.9449C6.85291 46.8171 5.75065 43.3581 5.75065 37.8902V24.4319C5.75065 18.9639 6.85291 15.5049 8.98068 13.3772C11.1085 11.2494 14.5675 10.1471 20.0354 10.1471H33.4937C38.9616 10.1471 42.4206 11.2494 44.5484 13.3772C46.6762 15.5049 47.7784 18.9639 47.7784 24.4319V37.8902C47.7784 43.3581 46.6762 46.8171 44.5484 48.9449C42.4206 51.0727 38.9616 52.1749 33.4937 52.1749Z",
    fill: "white",
    stroke: "#1B1D1F",
    strokeWidth: 2.83333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4316 43.9147V38.248",
    stroke: "#1B1D1F",
    strokeWidth: 3.25833,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2969 43.9149V32.5815",
    stroke: "#1B1D1F",
    strokeWidth: 3.25833,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3633 43.9147V29.748",
    stroke: "#1B1D1F",
    strokeWidth: 3.25833,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2285 43.9146L39.2285 22.6646",
    stroke: "#9F6BFF",
    strokeWidth: 4.25,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7733 3.73462L30.5655 5.34885C30.9616 6.14182 31.9518 6.87816 32.8288 7.04808L33.9039 7.218C37.1293 7.75608 37.8931 10.135 35.5732 12.4856L34.5829 13.4768C33.9322 14.1564 33.5645 15.4592 33.7625 16.3654L33.9039 16.9602C34.781 20.8684 32.7157 22.3693 29.3206 20.3303L28.585 19.9055C27.7079 19.3957 26.2934 19.3957 25.4163 19.9055L24.6807 20.3303C21.2573 22.3976 19.192 20.8684 20.0974 16.9602L20.2388 16.3654C20.4368 15.4592 20.0691 14.1564 19.4184 13.4768L18.4281 12.4856C16.1082 10.135 16.872 7.75608 20.0974 7.218L21.1725 7.04808C22.0212 6.90648 23.0397 6.14182 23.4358 5.34885L24.228 3.73462C25.7558 0.647706 28.2455 0.647706 29.7733 3.73462Z",
    fill: "#9F6BFF",
    stroke: "#1B1D1F",
    strokeWidth: 2.83333
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.252 7.23991V15.2529H26.5807V8.82259H26.5365L24.6992 9.97363V8.50163L26.6803 7.23991H28.252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersTable);
export default __webpack_public_path__ + "static/media/users_table.e05c2bceb88b524af5ec4b57404bfe56.svg";
export { ForwardRef as ReactComponent };